"use strict";
exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/node_modules/rxjs/util/isArray.js
// module id = ../../../../rxjs/util/isArray.js
// module chunks = vendor